import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/icon/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/mirofish/footer-directory-badges.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/mirofish/site-header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/mirofish/use-case-cta-link.tsx");
